import { Component } from '@verndale/core';

class CardDetailsModal extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      modal: this.el.querySelector<HTMLElement>('.card-details-modal'),
      closeButton: this.el.querySelector<HTMLElement>(
        '.card-details-modal__close'
      )
    };
  }

  addListeners() {
    this.el.addEventListener('click', this.showModal.bind(this));
    (this.dom.closeButton as HTMLElement)?.addEventListener(
      'click',
      this.closeModal.bind(this)
    );
  }

  showModal(e: Event) {
    e.stopPropagation();
    if (this.dom.modal) {
      (this.dom.modal as HTMLDialogElement).showModal();
    }
    (this.dom.modal as HTMLElement)?.addEventListener(
      'click',
      this.closeModalOnOutsideClick.bind(this)
    );
  }

  closeModal(e: Event) {
    e.stopPropagation();
    if (this.dom.modal) {
      (this.dom.modal as HTMLDialogElement).close();
    }
    (this.dom.modal as HTMLElement).removeEventListener(
      'click',
      this.closeModalOnOutsideClick.bind(this)
    );
  }

  closeModalOnOutsideClick(e: Event) {
    const modalInner = (this.dom.modal as HTMLElement).querySelector(
      '.card-details-modal__inner'
    );
    if (!modalInner?.contains(e.target as Node)) {
      this.closeModal(e);
    }
  }
}

export default CardDetailsModal;
